import theme from "../../../../styles/theme";

/* ============================================================================
   MÉTADONNÉES FAMILLES
============================================================================ */
export const familyMeta = {
  water_tower: {
    label: "Water Tower",
    shortLabel: "Water Tower",
    color: theme.Generic.blue.dark.bg,
    lightBg: theme.Generic.blue.pastel.bg,
    lightBorder: theme.Generic.blue.pastel.border,
  },
  culvert: {
    label: "Culvert",
    shortLabel: "Culvert",
    color: theme.Generic.grey.dark.bg,
    lightBg: theme.Generic.grey.pastel.bg,
    lightBorder: theme.Generic.grey.pastel.border,
  },
  borehole: {
    label: "Borehole",
    shortLabel: "Borehole",
    color: theme.Generic.teal.dark.bg,
    lightBg: theme.Generic.teal.pastel.bg,
    lightBorder: theme.Generic.teal.pastel.border,
  },
  solar_field: {
    label: "Solar Field",
    shortLabel: "Solar Field",
    color: theme.Generic.yellow.dark.bg,
    lightBg: theme.Generic.yellow.pastel.bg,
    lightBorder: theme.Generic.yellow.pastel.border,
  },
};

/* ============================================================================
   SCHÉMA DES CHAMPS
============================================================================ */
export const fieldSchema = {
  water_tower: {
    summarySourceField: "capacity",
    quickFields: [
      { name: "capacity", label: "Cap.", control: "number", labelWidth: 58 },
      { name: "height", label: "Ht.", control: "number", labelWidth: 58 },
      {
        name: "structureType",
        label: "Type",
        control: "select",
        labelWidth: 58,
        options: [
          { value: "Béton", label: "Béton" },
          { value: "Acier", label: "Acier" },
          { value: "Mixte", label: "Mixte" },
        ],
      },
    ],
    detailFields: commonAssetDetailFields(),
  },

  culvert: {
    summarySourceField: "length",
    quickFields: [
      { name: "length", label: "Long.", control: "number", labelWidth: 58 },
      { name: "diameter", label: "Ø", control: "number", labelWidth: 58 },
      {
        name: "material",
        label: "Mat.",
        control: "select",
        labelWidth: 58,
        options: [
          { value: "Béton", label: "Béton" },
          { value: "PEHD", label: "PEHD" },
          { value: "Acier", label: "Acier" },
        ],
      },
    ],
    detailFields: commonAssetDetailFields(),
  },

  borehole: {
    summarySourceField: "depth",
    quickFields: [
      { name: "depth", label: "Prof.", control: "number", labelWidth: 58 },
      { name: "count", label: "Nb", control: "stepper" },
      {
        name: "pumpType",
        label: "Pompe",
        control: "select",
        labelWidth: 58,
        options: [
          { value: "Immergée", label: "Immergée" },
          { value: "Surface", label: "Surface" },
          { value: "Aucune", label: "Aucune" },
        ],
      },
    ],
    detailFields: commonAssetDetailFields(),
  },

  solar_field: {
    summarySourceField: "power",
    quickFields: [
      { name: "power", label: "kWp", control: "number", labelWidth: 58 },
      { name: "tables", label: "Tables", control: "stepper" },
      {
        name: "mounting",
        label: "Pose",
        control: "select",
        labelWidth: 58,
        options: [
          { value: "Sol", label: "Sol" },
          { value: "Toiture", label: "Toiture" },
          { value: "Mixte", label: "Mixte" },
        ],
      },
    ],
    detailFields: commonAssetDetailFields(),
  },
};

function commonAssetDetailFields() {
  return [
    {
      name: "status",
      label: "Statut",
      control: "select",
      labelWidth: 64,
      options: [
        { value: "Prévu", label: "Prévu" },
        { value: "Option", label: "Option" },
        { value: "À valider", label: "À valider" },
        { value: "Retenu", label: "Retenu" },
      ],
    },
    {
      name: "notes",
      label: "Note",
      control: "text",
      labelWidth: 64,
      placeholder: "Observation rapide...",
    },
  ];
}

/* ============================================================================
   DONNÉES INITIALES
============================================================================ */
export const createDefaultSpecificAssets = () => [
  {
    id: "water-tower-01",
    entityType: "SPECIFIC_ASSET",
    family: "water_tower",
    title: "Château d’eau",
    subtitle: "Stockage surélevé",
    active: true,
    unit: "m³",
    summaryValue: 300,
    summaryLabel: "Capacité indicative",
    fields: {
      capacity: 300,
      height: 25,
      structureType: "Béton",
      status: "Retenu",
      notes: "",
    },
  },
  {
    id: "culvert-01",
    entityType: "SPECIFIC_ASSET",
    family: "culvert",
    title: "Dalot hydraulique",
    subtitle: "Traversée / ouvrage de drainage",
    active: true,
    unit: "ml",
    summaryValue: 18,
    summaryLabel: "Longueur indicative",
    fields: {
      length: 18,
      diameter: 1500,
      material: "Béton",
      status: "Prévu",
      notes: "",
    },
  },
  {
    id: "borehole-01",
    entityType: "SPECIFIC_ASSET",
    family: "borehole",
    title: "Forage",
    subtitle: "Captage / production",
    active: true,
    unit: "m",
    summaryValue: 120,
    summaryLabel: "Profondeur indicative",
    fields: {
      depth: 120,
      count: 2,
      pumpType: "Immergée",
      status: "À valider",
      notes: "",
    },
  },
  {
    id: "solar-field-01",
    entityType: "SPECIFIC_ASSET",
    family: "solar_field",
    title: "Champ solaire",
    subtitle: "Production photovoltaïque",
    active: false,
    unit: "kWp",
    summaryValue: 250,
    summaryLabel: "Puissance indicative",
    fields: {
      power: 250,
      tables: 12,
      mounting: "Sol",
      status: "Option",
      notes: "",
    },
  },
];